module.exports = __webpack_public_path__ + "img/mail-confirmed.48f723c4.svg";